import React, { useState } from 'react';
import Helmet from 'react-helmet';
import Tower4Cover from '../images/projects/tower4_cover.png';


 const structuredData = {
    "@context": "https://schema.org",
    "@type": "RealEstateListing",
    "name": "Tower 4",
    "description": "Premium commercial office spaces available for sale at Tower 4, located on Capital Square B-17, Islamabad. Flexible 4-quarter installment plan available.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Capital Square, B-17",
      "addressLocality": "Islamabad",
      "addressRegion": "ICT",
      "addressCountry": "PK"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "PKR",
      "price": "522240000",
      "availability": "https://schema.org/InStock"
    }
  };

const Tower4 = () => {
  const [activeUnit, setActiveUnit] = useState('type-a');
  const WHATSAPP = '923487172565';

  const UNITS = [
    {
      id: 'type-a',
      floor: 'LG to 4th',
      area: 'Various Sizes',
      title: 'Ground + 4 Floors · Retail & Fashion',
      features: [
        'Women Clothing & Fancy Wear',
        'Men Clothing & Child Clothing',
        'Cosmetics & Shoe Shops',
        'Jewelry Shops & Home Décor',
        'Centrally Air Conditioned',
        '4 Service Lifts Available'
      ],
      image: 'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=800&q=80'
    },
    {
      id: 'type-b',
      floor: '5th Floor',
      area: 'Specialty Shops',
      title: '5th Floor · Accessories & Garments',
      features: [
        'Lace & Accessories Shop',
        'Hosiery & Garments Store',
        'Tailor Shops',
        'Toy Shops',
        'Centrally Air Conditioned',
        'High Footfall Area'
      ],
      image: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=800&q=80'
    },
    {
      id: 'type-c',
      floor: '6th & 7th',
      area: 'Mobile & Electronics',
      title: '6th & 7th Floor · Mobile Market',
      features: [
        'Mobile Phones & Accessories',
        'Electronics & Gadgets',
        'Repair & Service Centers',
        'High Traffic Location',
        'Modern Infrastructure',
        '24/7 Security'
      ],
      image: 'https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=800&q=80'
    }
  ];

  const PAST_PROJECTS = [
    'Sukoon Vista · Block A, B-17',
    'Mountdale Tower · Block B1, B-17',
    'Mountdale Arcade · Block D, B-17',
    '50 Square · Faisal Margallah City',
    'C Square 2 · E-17 Markaz'
  ];

  const AMENITIES = [
    'Centrally Air Conditioned',
    '4 Service Lifts',
    'Reserved Parking',
    '24/7 Security',
    'Power Backup',
    'Fire Safety System',
    'Modern Sanitation',
    'High Speed Elevators'
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
          <Helmet>
                  <title>Tower 4 | Premium Commercial Offices in Blue Area, Islamabad</title>
                  <meta name="description" content="Invest in Tower 4 on Jinnah Avenue. Premium commercial office spaces with flexible 25% down payment and 4 quarterly installments. Safe & secure investment in Islamabad." />
                  <meta name="keywords" content="Tower 4, Blue Area Islamabad, Commercial Offices, Real Estate Islamabad, Jinnah Avenue, Property Investment, Marketing & Developers, Office Space for Sale" />
                  
                  {/* Open Graph / Facebook */}
                  <meta property="og:type" content="website" />
                  <meta property="og:url" content="https://b7tower.com/" />
                  <meta property="og:title" content="Tower 4 | Premium Commercial Offices in Blue Area, Islamabad" />
                  <meta property="og:description" content="Tower 4 offers premium commercial office spaces in the heart of Islamabad. Secure your investment with a 25% down payment today." />
                  <meta property="og:image" content={Tower4Cover} />
        
                  {/* Twitter */}
                  <meta property="twitter:card" content="summary_large_image" />
                  <meta property="twitter:url" content="https://b7tower.com/" />
                  <meta property="twitter:title" content="Tower 4 | Premium Commercial Offices in Blue Area, Islamabad" />
                  <meta property="twitter:description" content="Tower 4 offers premium commercial office spaces in the heart of Islamabad. Secure your investment with a 25% down payment today." />
                  <meta property="twitter:image" content={Tower4Cover} />
                  
                  {/* JSON-LD Structured Data */}
                  <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                  </script>
                </Helmet>
      {/* Hero Section */}
      <section 
        className="relative min-h-[90vh] flex items-center justify-center px-4 bg-cover bg-center"
        style={{ 
          backgroundImage: `url(${Tower4Cover})`
        }}
      >
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <div className="inline-block px-6 py-2 mb-4 border border-white/30 rounded-full text-sm tracking-widest uppercase bg-black/20 backdrop-blur-sm">
            <i className="fas fa-building mr-2"></i> Hussain Builders & Marketeers
          </div>
          <h1 className="text-5xl md:text-7xl font-bold leading-tight">
            Tower <span className="text-yellow-400">4</span> · B-17
          </h1>
          <p className="text-lg md:text-2xl mt-4 max-w-2xl mx-auto text-white/90">
            One Stop Shopping Solution · Ground + 8 Fully Commercial Floors
          </p>
          <p className="text-md text-yellow-300 mt-2">Need of the Hour: Local Shops</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`https://wa.me/${WHATSAPP}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg flex items-center justify-center gap-3 transition-all hover:scale-105"
            >
              <i className="fab fa-whatsapp text-2xl"></i> Book Now · WhatsApp
            </a>
            <button
              onClick={() => document.getElementById('units')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/20 backdrop-blur-sm border border-white/40 px-8 py-4 rounded-full text-lg font-medium hover:bg-white/30 transition-all flex items-center gap-2"
            >
              <i className="fas fa-arrow-down"></i> View Floor Plans
            </button>
          </div>
          <div className="mt-6 text-sm opacity-75 flex flex-wrap justify-center gap-4">
            <span><i className="fas fa-check-circle text-green-400 mr-1"></i> 30% Down Payment</span>
            <span><i className="fas fa-check-circle text-green-400 mr-1"></i> 12 Quarterly Installments</span>
            <span><i className="fas fa-check-circle text-green-400 mr-1"></i> 3 Years Plan</span>
          </div>
        </div>
      </section>

      {/* Past Projects Section */}
      <section className="py-12 px-4 max-w-7xl mx-auto bg-gray-50">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 inline-block border-b-4 border-yellow-600 pb-2">
            <i className="fas fa-history mr-3 text-yellow-600"></i> Past & Current Projects
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PAST_PROJECTS.map((project, idx) => (
            <div key={idx} className="bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all border-l-4 border-yellow-500 flex items-center gap-3">
              <i className="fas fa-check-circle text-yellow-500 text-xl"></i>
              <span className="font-medium text-gray-700">{project}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-12 px-4 max-w-6xl mx-auto bg-white rounded-3xl shadow-sm my-8">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
            <i className="fas fa-info-circle mr-3 text-yellow-600"></i> Introduction
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto my-4"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            A Purely Commercial Project Offering a Diversified Experience & Range of Local Shops for End Customers.
          </p>
          <p className="mt-4 text-gray-600">Block C · Sector B-17 · Islamabad</p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <span className="bg-yellow-100 text-yellow-800 px-6 py-2 rounded-full font-medium">Centrally Air Conditioned</span>
            <span className="bg-yellow-100 text-yellow-800 px-6 py-2 rounded-full font-medium">All You Need: Under One Roof</span>
            <span className="bg-yellow-100 text-yellow-800 px-6 py-2 rounded-full font-medium">4 Service Lifts</span>
          </div>
        </div>
      </section>

      {/* Units Section */}
      <section id="units" className="py-16 px-4 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 inline-block border-b-4 border-yellow-600 pb-2">
            <i className="fas fa-layer-group mr-3 text-yellow-600"></i> Floor Plans & Shops
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Choose from our diverse range of commercial spaces across multiple floors.
          </p>
        </div>

        {/* Unit Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {UNITS.map((unit) => (
            <button
              key={unit.id}
              onClick={() => setActiveUnit(unit.id)}
              className={`px-6 py-2 rounded-full font-medium transition-all border ${
                activeUnit === unit.id
                  ? 'bg-yellow-600 text-white border-yellow-600 shadow-lg'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
              }`}
            >
              {unit.floor} · {unit.area}
            </button>
          ))}
        </div>

        {/* Active Unit Card */}
        {UNITS.map((unit) => {
          if (unit.id !== activeUnit) return null;
          return (
            <div 
              key={unit.id} 
              className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all md:flex"
            >
              <div className="md:w-1/2 h-72 md:h-auto">
                <img 
                  src={unit.image} 
                  alt={unit.title} 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 md:p-10 md:w-1/2">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="bg-yellow-100 text-yellow-800 px-4 py-1 rounded-full text-sm font-bold">
                    {unit.floor}
                  </span>
                  <span className="bg-gray-200 px-4 py-1 rounded-full text-sm font-medium">
                    <i className="fas fa-store mr-1"></i> Commercial Shops
                  </span>
                </div>
                <h3 className="text-2xl font-bold mt-3">{unit.title}</h3>
                <ul className="mt-4 space-y-2 text-gray-700">
                  {unit.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <i className="fas fa-check-circle text-yellow-600 mt-1"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 pt-4 border-t border-gray-200 flex flex-wrap gap-3">
                  <a
                    href={`https://wa.me/${WHATSAPP}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-full font-medium flex items-center gap-2 shadow transition-all"
                  >
                    <i className="fab fa-whatsapp"></i> Inquire Now
                  </a>
                  <button className="border border-gray-400 px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-all flex items-center gap-2">
                    <i className="fas fa-file-invoice-dollar"></i> Payment Plan
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        <div className="mt-12 text-center text-sm text-gray-500 italic border-t border-gray-200 pt-8">
          <i className="fas fa-asterisk text-yellow-600 mr-1"></i> All shops are centrally air conditioned with service lifts and parking.
        </div>
      </section>

      {/* Investment Potential */}
      <section className="py-16 px-4 bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-4">
            <i className="fas fa-chart-line text-yellow-600 mr-3"></i> Investment Potential
          </h3>
          <p className="text-center text-gray-600 mb-8">High ROIs & Rental Yields in B-17</p>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-3">
              {[
                'Located in Sector B-17, Zone II, Islamabad – Margallah Avenue',
                'Genuine Need of Local Shops in the Area',
                'MPCHS B-17: Follows International Development Standards',
                'Ever Growing Residential Population',
                'Growing Consumerism in B-17 & Vicinity',
                'High ROIs & Rental Yields'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3 bg-gray-50 p-3 rounded-lg">
                  <i className="fas fa-check-circle text-yellow-600 mt-1"></i>
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-yellow-50 p-8 rounded-2xl border border-yellow-200 flex flex-col justify-center items-center text-center">
              <div className="text-4xl font-bold text-yellow-700">30%</div>
              <p className="text-xl font-semibold">Down Payment</p>
              <div className="text-3xl font-bold text-yellow-700 mt-4">12</div>
              <p className="text-xl font-semibold">Quarterly Installments</p>
              <p className="text-lg text-gray-600">(3 Years Plan)</p>
              <a
                href={`https://wa.me/${WHATSAPP}`}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-full font-medium flex items-center gap-2 shadow transition-all"
              >
                <i className="fab fa-whatsapp"></i> Get Payment Plan Details
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Amenities Section */}
      <section className="py-16 px-4 bg-gray-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-4">
            <i className="fas fa-concierge-bell text-yellow-600 mr-3"></i> Amenities
          </h3>
          <p className="text-center text-gray-600 mb-10">Modern facilities for a premium shopping experience.</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {AMENITIES.map((item, idx) => (
              <div 
                key={idx} 
                className="bg-white hover:bg-yellow-50 p-5 rounded-2xl text-center shadow-sm transition-all border border-gray-100 flex flex-col items-center"
              >
                <i className="fas fa-check-circle text-yellow-600 text-2xl mb-2"></i>
                <span className="font-medium text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-yellow-600/20 rounded-full flex items-center justify-center text-2xl">
              <i className="fas fa-building text-yellow-500"></i>
            </div>
            <div>
              <p className="font-bold text-lg">Hussain Builders</p>
              <p className="text-sm text-gray-400">Hussain Marketing · A Name of Trust</p>
            </div>
          </div>
          <div className="text-sm text-gray-400 flex flex-wrap gap-4">
            <span><i className="fas fa-phone-alt mr-1"></i> UAN: 0331-1111017</span>
            <span><i className="fas fa-map-pin mr-1"></i> Office 723, Block A, B-17</span>
            <a 
              href={`https://wa.me/${WHATSAPP}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-green-400 hover:text-green-300 transition"
            >
              <i className="fab fa-whatsapp mr-1"></i> WhatsApp
            </a>
          </div>
        </div>
        <div className="mt-6 text-center text-xs text-gray-600 border-t border-gray-800 pt-4">
          © 2026 Tower 4 · All rights reserved. Presented by Hussain Builders & Marketeers.
          <br />
          <span className="text-gray-700">www.tower4.com.pk</span>
        </div>
      </footer>
    </div>
  );
};

export default Tower4;